/**
 * Com qual mestre a Prosa fala — e a memória dessa escolha.
 *
 * A Prosa é a conversa de voz: quem a abre está com as mãos ocupadas, e
 * escolher o motor toda vez seria um passo a mais no pior momento possível.
 * Por isso a escolha fica guardada. E por isso ela é uma PREFERÊNCIA, nunca
 * uma amarra: o mestre daquele motor pode ter sido encerrado desde ontem, e a
 * Prosa tem de abrir assim mesmo.
 *
 * Função pura separada do componente porque a regra que importa (o que fazer
 * quando a preferência não existe mais) é exatamente a que um teste de tela
 * mediria mal: ela só aparece num estado que é chato de montar na tela e
 * trivial de montar aqui.
 */

const CHAVE = 'remoto:prosa:motor';

/** O motor preferido, ou vazio. Nunca lança: `localStorage` pode não existir. */
export function lerMotorDaProsa(): string {
  try {
    return window.localStorage.getItem(CHAVE) ?? '';
  } catch {
    return '';
  }
}

export function guardarMotorDaProsa(motor: string): void {
  try {
    window.localStorage.setItem(CHAVE, motor);
  } catch {
    // Navegador com armazenamento bloqueado ainda usa a Prosa; ele só não
    // lembra da escolha. Perder a memória não pode impedir a conversa.
  }
}

export interface MestreDaProsa {
  id: string;
  motor?: string;
}

/**
 * Qual mestre a Prosa abre, dada a lista e a preferência.
 *
 * **Preferência órfã NÃO deixa a tela vazia.** Se o mestre preferido não está
 * mais na lista — encerrado, ou aquele motor nunca teve um —, abre-se o
 * primeiro que existir. Uma tela de voz que não abre porque uma escolha de
 * ontem apontava para uma conversa morta é a pior falha possível aqui: quem
 * está com as mãos ocupadas não tem como investigar.
 */
export function mestreDaProsa(
  mestres: readonly MestreDaProsa[],
  preferido: string,
): MestreDaProsa | undefined {
  if (preferido) {
    const escolhido = mestres.find((m) => (m.motor ?? 'CLAUDE') === preferido);
    if (escolhido) return escolhido;
  }
  return mestres[0];
}
